function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var loadScript = function load(src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0];
  var script = document.createElement('script');

  if (typeof opts === 'function') {
    cb = opts;
    opts = {};
  }

  opts = opts || {};

  cb = cb || function () {};

  script.type = opts.type || 'text/javascript';
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true;
  script.src = src;

  if (opts.attrs) {
    setAttributes(script, opts.attrs);
  }

  if (opts.text) {
    script.text = '' + opts.text;
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd;
  onend(script, cb); // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload

  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script);
};

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd(script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null;
    cb(null, script);
  };

  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null;
    cb(new Error('Failed to load ' + this.src), script);
  };
}

function ieOnEnd(script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return;
    this.onreadystatechange = null;
    cb(null, script); // there is no way to catch loading errors in IE8
  };
}

var _function = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getEndomorphismMonoid = exports.not = exports.SK = exports.hole = exports.pipe = exports.untupled = exports.tupled = exports.absurd = exports.decrement = exports.increment = exports.tuple = exports.flow = exports.flip = exports.constVoid = exports.constUndefined = exports.constNull = exports.constFalse = exports.constTrue = exports.constant = exports.unsafeCoerce = exports.identity = exports.apply = exports.getRing = exports.getSemiring = exports.getMonoid = exports.getSemigroup = exports.getBooleanAlgebra = void 0; // -------------------------------------------------------------------------------------
  // instances
  // -------------------------------------------------------------------------------------

  /**
   * @category instances
   * @since 2.10.0
   */

  var getBooleanAlgebra = function getBooleanAlgebra(B) {
    return function () {
      return {
        meet: function meet(x, y) {
          return function (a) {
            return B.meet(x(a), y(a));
          };
        },
        join: function join(x, y) {
          return function (a) {
            return B.join(x(a), y(a));
          };
        },
        zero: function zero() {
          return B.zero;
        },
        one: function one() {
          return B.one;
        },
        implies: function implies(x, y) {
          return function (a) {
            return B.implies(x(a), y(a));
          };
        },
        not: function not(x) {
          return function (a) {
            return B.not(x(a));
          };
        }
      };
    };
  };

  exports.getBooleanAlgebra = getBooleanAlgebra;
  /**
   * Unary functions form a semigroup as long as you can provide a semigroup for the codomain.
   *
   * @example
   * import { Predicate, getSemigroup } from 'fp-ts/function'
   * import * as B from 'fp-ts/boolean'
   *
   * const f: Predicate<number> = (n) => n <= 2
   * const g: Predicate<number> = (n) => n >= 0
   *
   * const S1 = getSemigroup(B.SemigroupAll)<number>()
   *
   * assert.deepStrictEqual(S1.concat(f, g)(1), true)
   * assert.deepStrictEqual(S1.concat(f, g)(3), false)
   *
   * const S2 = getSemigroup(B.SemigroupAny)<number>()
   *
   * assert.deepStrictEqual(S2.concat(f, g)(1), true)
   * assert.deepStrictEqual(S2.concat(f, g)(3), true)
   *
   * @category instances
   * @since 2.10.0
   */

  var getSemigroup = function getSemigroup(S) {
    return function () {
      return {
        concat: function concat(f, g) {
          return function (a) {
            return S.concat(f(a), g(a));
          };
        }
      };
    };
  };

  exports.getSemigroup = getSemigroup;
  /**
   * Unary functions form a monoid as long as you can provide a monoid for the codomain.
   *
   * @example
   * import { Predicate } from 'fp-ts/Predicate'
   * import { getMonoid } from 'fp-ts/function'
   * import * as B from 'fp-ts/boolean'
   *
   * const f: Predicate<number> = (n) => n <= 2
   * const g: Predicate<number> = (n) => n >= 0
   *
   * const M1 = getMonoid(B.MonoidAll)<number>()
   *
   * assert.deepStrictEqual(M1.concat(f, g)(1), true)
   * assert.deepStrictEqual(M1.concat(f, g)(3), false)
   *
   * const M2 = getMonoid(B.MonoidAny)<number>()
   *
   * assert.deepStrictEqual(M2.concat(f, g)(1), true)
   * assert.deepStrictEqual(M2.concat(f, g)(3), true)
   *
   * @category instances
   * @since 2.10.0
   */

  var getMonoid = function getMonoid(M) {
    var getSemigroupM = exports.getSemigroup(M);
    return function () {
      return {
        concat: getSemigroupM().concat,
        empty: function empty() {
          return M.empty;
        }
      };
    };
  };

  exports.getMonoid = getMonoid;
  /**
   * @category instances
   * @since 2.10.0
   */

  var getSemiring = function getSemiring(S) {
    return {
      add: function add(f, g) {
        return function (x) {
          return S.add(f(x), g(x));
        };
      },
      zero: function zero() {
        return S.zero;
      },
      mul: function mul(f, g) {
        return function (x) {
          return S.mul(f(x), g(x));
        };
      },
      one: function one() {
        return S.one;
      }
    };
  };

  exports.getSemiring = getSemiring;
  /**
   * @category instances
   * @since 2.10.0
   */

  var getRing = function getRing(R) {
    var S = exports.getSemiring(R);
    return {
      add: S.add,
      mul: S.mul,
      one: S.one,
      zero: S.zero,
      sub: function sub(f, g) {
        return function (x) {
          return R.sub(f(x), g(x));
        };
      }
    };
  };

  exports.getRing = getRing; // -------------------------------------------------------------------------------------
  // utils
  // -------------------------------------------------------------------------------------

  /**
   * @since 2.11.0
   */

  var apply = function apply(a) {
    return function (f) {
      return f(a);
    };
  };

  exports.apply = apply;
  /**
   * @since 2.0.0
   */

  function identity(a) {
    return a;
  }

  exports.identity = identity;
  /**
   * @since 2.0.0
   */

  exports.unsafeCoerce = identity;
  /**
   * @since 2.0.0
   */

  function constant(a) {
    return function () {
      return a;
    };
  }

  exports.constant = constant;
  /**
   * A thunk that returns always `true`.
   *
   * @since 2.0.0
   */

  exports.constTrue = /*#__PURE__*/constant(true);
  /**
   * A thunk that returns always `false`.
   *
   * @since 2.0.0
   */

  exports.constFalse = /*#__PURE__*/constant(false);
  /**
   * A thunk that returns always `null`.
   *
   * @since 2.0.0
   */

  exports.constNull = /*#__PURE__*/constant(null);
  /**
   * A thunk that returns always `undefined`.
   *
   * @since 2.0.0
   */

  exports.constUndefined = /*#__PURE__*/constant(undefined);
  /**
   * A thunk that returns always `void`.
   *
   * @since 2.0.0
   */

  exports.constVoid = exports.constUndefined;
  /**
   * Flips the order of the arguments of a function of two arguments.
   *
   * @since 2.0.0
   */

  function flip(f) {
    return function (b, a) {
      return f(a, b);
    };
  }

  exports.flip = flip;

  function flow(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch (arguments.length) {
      case 1:
        return ab;

      case 2:
        return function () {
          return bc(ab.apply(this, arguments));
        };

      case 3:
        return function () {
          return cd(bc(ab.apply(this, arguments)));
        };

      case 4:
        return function () {
          return de(cd(bc(ab.apply(this, arguments))));
        };

      case 5:
        return function () {
          return ef(de(cd(bc(ab.apply(this, arguments)))));
        };

      case 6:
        return function () {
          return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
        };

      case 7:
        return function () {
          return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
        };

      case 8:
        return function () {
          return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
        };

      case 9:
        return function () {
          return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
        };
    }

    return;
  }

  exports.flow = flow;
  /**
   * @since 2.0.0
   */

  function tuple() {
    var t = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      t[_i] = arguments[_i];
    }

    return t;
  }

  exports.tuple = tuple;
  /**
   * @since 2.0.0
   */

  function increment(n) {
    return n + 1;
  }

  exports.increment = increment;
  /**
   * @since 2.0.0
   */

  function decrement(n) {
    return n - 1;
  }

  exports.decrement = decrement;
  /**
   * @since 2.0.0
   */

  function absurd(_) {
    throw new Error('Called `absurd` function which should be uncallable');
  }

  exports.absurd = absurd;
  /**
   * Creates a tupled version of this function: instead of `n` arguments, it accepts a single tuple argument.
   *
   * @example
   * import { tupled } from 'fp-ts/function'
   *
   * const add = tupled((x: number, y: number): number => x + y)
   *
   * assert.strictEqual(add([1, 2]), 3)
   *
   * @since 2.4.0
   */

  function tupled(f) {
    return function (a) {
      return f.apply(void 0, a);
    };
  }

  exports.tupled = tupled;
  /**
   * Inverse function of `tupled`
   *
   * @since 2.4.0
   */

  function untupled(f) {
    return function () {
      var a = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
      }

      return f(a);
    };
  }

  exports.untupled = untupled;

  function pipe(a, ab, bc, cd, de, ef, fg, gh, hi, ij, jk, kl, lm, mn, no, op, pq, qr, rs, st) {
    switch (arguments.length) {
      case 1:
        return a;

      case 2:
        return ab(a);

      case 3:
        return bc(ab(a));

      case 4:
        return cd(bc(ab(a)));

      case 5:
        return de(cd(bc(ab(a))));

      case 6:
        return ef(de(cd(bc(ab(a)))));

      case 7:
        return fg(ef(de(cd(bc(ab(a))))));

      case 8:
        return gh(fg(ef(de(cd(bc(ab(a)))))));

      case 9:
        return hi(gh(fg(ef(de(cd(bc(ab(a))))))));

      case 10:
        return ij(hi(gh(fg(ef(de(cd(bc(ab(a)))))))));

      case 11:
        return jk(ij(hi(gh(fg(ef(de(cd(bc(ab(a))))))))));

      case 12:
        return kl(jk(ij(hi(gh(fg(ef(de(cd(bc(ab(a)))))))))));

      case 13:
        return lm(kl(jk(ij(hi(gh(fg(ef(de(cd(bc(ab(a))))))))))));

      case 14:
        return mn(lm(kl(jk(ij(hi(gh(fg(ef(de(cd(bc(ab(a)))))))))))));

      case 15:
        return no(mn(lm(kl(jk(ij(hi(gh(fg(ef(de(cd(bc(ab(a))))))))))))));

      case 16:
        return op(no(mn(lm(kl(jk(ij(hi(gh(fg(ef(de(cd(bc(ab(a)))))))))))))));

      case 17:
        return pq(op(no(mn(lm(kl(jk(ij(hi(gh(fg(ef(de(cd(bc(ab(a))))))))))))))));

      case 18:
        return qr(pq(op(no(mn(lm(kl(jk(ij(hi(gh(fg(ef(de(cd(bc(ab(a)))))))))))))))));

      case 19:
        return rs(qr(pq(op(no(mn(lm(kl(jk(ij(hi(gh(fg(ef(de(cd(bc(ab(a))))))))))))))))));

      case 20:
        return st(rs(qr(pq(op(no(mn(lm(kl(jk(ij(hi(gh(fg(ef(de(cd(bc(ab(a)))))))))))))))))));
    }

    return;
  }

  exports.pipe = pipe;
  /**
   * Type hole simulation
   *
   * @since 2.7.0
   */

  exports.hole = absurd;
  /**
   * @since 2.11.0
   */

  var SK = function SK(_, b) {
    return b;
  };

  exports.SK = SK;
  /**
   * Use `Predicate` module instead.
   *
   * @since 2.0.0
   * @deprecated
   */

  function not(predicate) {
    return function (a) {
      return !predicate(a);
    };
  }

  exports.not = not;
  /**
   * Use `Endomorphism` module instead.
   *
   * @category instances
   * @since 2.10.0
   * @deprecated
   */

  var getEndomorphismMonoid = function getEndomorphismMonoid() {
    return {
      concat: function concat(first, second) {
        return flow(first, second);
      },
      empty: identity
    };
  };

  exports.getEndomorphismMonoid = getEndomorphismMonoid;
})(_function);

var Either = {};
var Applicative = {};
var Apply = {};
Object.defineProperty(Apply, "__esModule", {
  value: true
});
Apply.sequenceS = Apply.sequenceT = Apply.getApplySemigroup = Apply.apS = Apply.apSecond = Apply.apFirst = Apply.ap = void 0;
var function_1$3 = _function;

function ap(F, G) {
  return function (fa) {
    return function (fab) {
      return F.ap(F.map(fab, function (gab) {
        return function (ga) {
          return G.ap(gab, ga);
        };
      }), fa);
    };
  };
}

Apply.ap = ap;

function apFirst(A) {
  return function (second) {
    return function (first) {
      return A.ap(A.map(first, function (a) {
        return function () {
          return a;
        };
      }), second);
    };
  };
}

Apply.apFirst = apFirst;

function apSecond(A) {
  return function (second) {
    return function (first) {
      return A.ap(A.map(first, function () {
        return function (b) {
          return b;
        };
      }), second);
    };
  };
}

Apply.apSecond = apSecond;

function apS(F) {
  return function (name, fb) {
    return function (fa) {
      return F.ap(F.map(fa, function (a) {
        return function (b) {
          var _a;

          return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
        };
      }), fb);
    };
  };
}

Apply.apS = apS;

function getApplySemigroup(F) {
  return function (S) {
    return {
      concat: function concat(first, second) {
        return F.ap(F.map(first, function (x) {
          return function (y) {
            return S.concat(x, y);
          };
        }), second);
      }
    };
  };
}

Apply.getApplySemigroup = getApplySemigroup;

function curried(f, n, acc) {
  return function (x) {
    var combined = Array(acc.length + 1);

    for (var i = 0; i < acc.length; i++) {
      combined[i] = acc[i];
    }

    combined[acc.length] = x;
    return n === 0 ? f.apply(null, combined) : curried(f, n - 1, combined);
  };
}

var tupleConstructors = {
  1: function _(a) {
    return [a];
  },
  2: function _(a) {
    return function (b) {
      return [a, b];
    };
  },
  3: function _(a) {
    return function (b) {
      return function (c) {
        return [a, b, c];
      };
    };
  },
  4: function _(a) {
    return function (b) {
      return function (c) {
        return function (d) {
          return [a, b, c, d];
        };
      };
    };
  },
  5: function _(a) {
    return function (b) {
      return function (c) {
        return function (d) {
          return function (e) {
            return [a, b, c, d, e];
          };
        };
      };
    };
  }
};

function getTupleConstructor(len) {
  if (!tupleConstructors.hasOwnProperty(len)) {
    tupleConstructors[len] = curried(function_1$3.tuple, len - 1, []);
  }

  return tupleConstructors[len];
}

function sequenceT(F) {
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var len = args.length;
    var f = getTupleConstructor(len);
    var fas = F.map(args[0], f);

    for (var i = 1; i < len; i++) {
      fas = F.ap(fas, args[i]);
    }

    return fas;
  };
}

Apply.sequenceT = sequenceT;

function getRecordConstructor(keys) {
  var len = keys.length;

  switch (len) {
    case 1:
      return function (a) {
        var _a;

        return _a = {}, _a[keys[0]] = a, _a;
      };

    case 2:
      return function (a) {
        return function (b) {
          var _a;

          return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
        };
      };

    case 3:
      return function (a) {
        return function (b) {
          return function (c) {
            var _a;

            return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
          };
        };
      };

    case 4:
      return function (a) {
        return function (b) {
          return function (c) {
            return function (d) {
              var _a;

              return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
            };
          };
        };
      };

    case 5:
      return function (a) {
        return function (b) {
          return function (c) {
            return function (d) {
              return function (e) {
                var _a;

                return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
              };
            };
          };
        };
      };

    default:
      return curried(function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        var r = {};

        for (var i = 0; i < len; i++) {
          r[keys[i]] = args[i];
        }

        return r;
      }, len - 1, []);
  }
}

function sequenceS(F) {
  return function (r) {
    var keys = Object.keys(r);
    var len = keys.length;
    var f = getRecordConstructor(keys);
    var fr = F.map(r[keys[0]], f);

    for (var i = 1; i < len; i++) {
      fr = F.ap(fr, r[keys[i]]);
    }

    return fr;
  };
}

Apply.sequenceS = sequenceS;
var Functor = {};
Object.defineProperty(Functor, "__esModule", {
  value: true
});
Functor.getFunctorComposition = Functor.bindTo = Functor.flap = Functor.map = void 0;
/**
 * A `Functor` is a type constructor which supports a mapping operation `map`.
 *
 * `map` can be used to turn functions `a -> b` into functions `f a -> f b` whose argument and return types use the type
 * constructor `f` to represent some computational context.
 *
 * Instances must satisfy the following laws:
 *
 * 1. Identity: `F.map(fa, a => a) <-> fa`
 * 2. Composition: `F.map(fa, a => bc(ab(a))) <-> F.map(F.map(fa, ab), bc)`
 *
 * @since 2.0.0
 */

var function_1$2 = _function;

function map(F, G) {
  return function (f) {
    return function (fa) {
      return F.map(fa, function (ga) {
        return G.map(ga, f);
      });
    };
  };
}

Functor.map = map;

function flap(F) {
  return function (a) {
    return function (fab) {
      return F.map(fab, function (f) {
        return f(a);
      });
    };
  };
}

Functor.flap = flap;

function bindTo(F) {
  return function (name) {
    return function (fa) {
      return F.map(fa, function (a) {
        var _a;

        return _a = {}, _a[name] = a, _a;
      });
    };
  };
}

Functor.bindTo = bindTo;
/** @deprecated */

function getFunctorComposition(F, G) {
  var _map = map(F, G);

  return {
    map: function map(fga, f) {
      return function_1$2.pipe(fga, _map(f));
    }
  };
}

Functor.getFunctorComposition = getFunctorComposition;
Object.defineProperty(Applicative, "__esModule", {
  value: true
});
Applicative.getApplicativeComposition = Applicative.getApplicativeMonoid = void 0;
/**
 * The `Applicative` type class extends the `Apply` type class with a `of` function, which can be used to create values
 * of type `f a` from values of type `a`.
 *
 * Where `Apply` provides the ability to lift functions of two or more arguments to functions whose arguments are
 * wrapped using `f`, and `Functor` provides the ability to lift functions of one argument, `pure` can be seen as the
 * function which lifts functions of _zero_ arguments. That is, `Applicative` functors support a lifting operation for
 * any number of function arguments.
 *
 * Instances must satisfy the following laws in addition to the `Apply` laws:
 *
 * 1. Identity: `A.ap(A.of(a => a), fa) <-> fa`
 * 2. Homomorphism: `A.ap(A.of(ab), A.of(a)) <-> A.of(ab(a))`
 * 3. Interchange: `A.ap(fab, A.of(a)) <-> A.ap(A.of(ab => ab(a)), fab)`
 *
 * Note. `Functor`'s `map` can be derived: `A.map(x, f) = A.ap(A.of(f), x)`
 *
 * @since 2.0.0
 */

var Apply_1 = Apply;
var function_1$1 = _function;
var Functor_1 = Functor;

function getApplicativeMonoid(F) {
  var f = Apply_1.getApplySemigroup(F);
  return function (M) {
    return {
      concat: f(M).concat,
      empty: F.of(M.empty)
    };
  };
}

Applicative.getApplicativeMonoid = getApplicativeMonoid;
/** @deprecated */

function getApplicativeComposition(F, G) {
  var map = Functor_1.getFunctorComposition(F, G).map;

  var _ap = Apply_1.ap(F, G);

  return {
    map: map,
    of: function of(a) {
      return F.of(G.of(a));
    },
    ap: function ap(fgab, fga) {
      return function_1$1.pipe(fgab, _ap(fga));
    }
  };
}

Applicative.getApplicativeComposition = getApplicativeComposition;
var Chain = {};
Object.defineProperty(Chain, "__esModule", {
  value: true
});
Chain.bind = Chain.chainFirst = void 0;

function chainFirst(M) {
  return function (f) {
    return function (first) {
      return M.chain(first, function (a) {
        return M.map(f(a), function () {
          return a;
        });
      });
    };
  };
}

Chain.chainFirst = chainFirst;

function bind$3(M) {
  return function (name, f) {
    return function (ma) {
      return M.chain(ma, function (a) {
        return M.map(f(a), function (b) {
          var _a;

          return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
        });
      });
    };
  };
}

Chain.bind = bind$3;
var ChainRec = {};
Object.defineProperty(ChainRec, "__esModule", {
  value: true
});
ChainRec.tailRec = void 0;
/**
 * @since 2.0.0
 */

var tailRec = function tailRec(startWith, f) {
  var ab = f(startWith);

  while (ab._tag === 'Left') {
    ab = f(ab.left);
  }

  return ab.right;
};

ChainRec.tailRec = tailRec;
var FromEither = {};
var internal = {};

var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
};

Object.defineProperty(internal, "__esModule", {
  value: true
});
internal.fromReadonlyNonEmptyArray = internal.has = internal.emptyRecord = internal.emptyReadonlyArray = internal.tail = internal.head = internal.isNonEmpty = internal.singleton = internal.right = internal.left = internal.isRight = internal.isLeft = internal.some = internal.none = internal.isSome = internal.isNone = void 0; // -------------------------------------------------------------------------------------
// Option
// -------------------------------------------------------------------------------------

/** @internal */

var isNone = function isNone(fa) {
  return fa._tag === 'None';
};

internal.isNone = isNone;
/** @internal */

var isSome = function isSome(fa) {
  return fa._tag === 'Some';
};

internal.isSome = isSome;
/** @internal */

internal.none = {
  _tag: 'None'
};
/** @internal */

var some = function some(a) {
  return {
    _tag: 'Some',
    value: a
  };
};

internal.some = some; // -------------------------------------------------------------------------------------
// Either
// -------------------------------------------------------------------------------------

/** @internal */

var isLeft = function isLeft(ma) {
  return ma._tag === 'Left';
};

internal.isLeft = isLeft;
/** @internal */

var isRight = function isRight(ma) {
  return ma._tag === 'Right';
};

internal.isRight = isRight;
/** @internal */

var left = function left(e) {
  return {
    _tag: 'Left',
    left: e
  };
};

internal.left = left;
/** @internal */

var right = function right(a) {
  return {
    _tag: 'Right',
    right: a
  };
};

internal.right = right; // -------------------------------------------------------------------------------------
// ReadonlyNonEmptyArray
// -------------------------------------------------------------------------------------

/** @internal */

var singleton = function singleton(a) {
  return [a];
};

internal.singleton = singleton;
/** @internal */

var isNonEmpty = function isNonEmpty(as) {
  return as.length > 0;
};

internal.isNonEmpty = isNonEmpty;
/** @internal */

var head = function head(as) {
  return as[0];
};

internal.head = head;
/** @internal */

var tail = function tail(as) {
  return as.slice(1);
};

internal.tail = tail; // -------------------------------------------------------------------------------------
// empty
// -------------------------------------------------------------------------------------

/** @internal */

internal.emptyReadonlyArray = [];
/** @internal */

internal.emptyRecord = {}; // -------------------------------------------------------------------------------------
// Record
// -------------------------------------------------------------------------------------

/** @internal */

internal.has = Object.prototype.hasOwnProperty; // -------------------------------------------------------------------------------------
// NonEmptyArray
// -------------------------------------------------------------------------------------

/** @internal */

var fromReadonlyNonEmptyArray = function fromReadonlyNonEmptyArray(as) {
  return __spreadArray([as[0]], as.slice(1));
};

internal.fromReadonlyNonEmptyArray = fromReadonlyNonEmptyArray;
/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */

var __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1(result, mod, k);
  }

  __setModuleDefault$1(result, mod);

  return result;
};

Object.defineProperty(FromEither, "__esModule", {
  value: true
});
FromEither.filterOrElse = FromEither.chainEitherK = FromEither.fromEitherK = FromEither.chainOptionK = FromEither.fromOptionK = FromEither.fromPredicate = FromEither.fromOption = void 0;
var function_1 = _function;

var _$1 = __importStar$1(internal);

function fromOption(F) {
  return function (onNone) {
    return function (ma) {
      return F.fromEither(_$1.isNone(ma) ? _$1.left(onNone()) : _$1.right(ma.value));
    };
  };
}

FromEither.fromOption = fromOption;

function fromPredicate(F) {
  return function (predicate, onFalse) {
    return function (a) {
      return F.fromEither(predicate(a) ? _$1.right(a) : _$1.left(onFalse(a)));
    };
  };
}

FromEither.fromPredicate = fromPredicate;

function fromOptionK(F) {
  var fromOptionF = fromOption(F);
  return function (onNone) {
    var from = fromOptionF(onNone);
    return function (f) {
      return function_1.flow(f, from);
    };
  };
}

FromEither.fromOptionK = fromOptionK;

function chainOptionK(F, M) {
  var fromOptionKF = fromOptionK(F);
  return function (onNone) {
    var from = fromOptionKF(onNone);
    return function (f) {
      return function (ma) {
        return M.chain(ma, from(f));
      };
    };
  };
}

FromEither.chainOptionK = chainOptionK;

function fromEitherK(F) {
  return function (f) {
    return function_1.flow(f, F.fromEither);
  };
}

FromEither.fromEitherK = fromEitherK;

function chainEitherK(F, M) {
  var fromEitherKF = fromEitherK(F);
  return function (f) {
    return function (ma) {
      return M.chain(ma, fromEitherKF(f));
    };
  };
}

FromEither.chainEitherK = chainEitherK;

function filterOrElse(F, M) {
  return function (predicate, onFalse) {
    return function (ma) {
      return M.chain(ma, function (a) {
        return F.fromEither(predicate(a) ? _$1.right(a) : _$1.left(onFalse(a)));
      });
    };
  };
}

FromEither.filterOrElse = filterOrElse;
var Separated = {};

(function (exports) {
  /**
   * ```ts
   * interface Separated<E, A> {
   *    readonly left: E
   *    readonly right: A
   * }
   * ```
   *
   * Represents a result of separating a whole into two parts.
   *
   * @since 2.10.0
   */
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.right = exports.left = exports.flap = exports.Functor = exports.Bifunctor = exports.URI = exports.bimap = exports.mapLeft = exports.map = exports.separated = void 0;
  var function_1 = _function;
  var Functor_1 = Functor; // -------------------------------------------------------------------------------------
  // constructors
  // -------------------------------------------------------------------------------------

  /**
   * @category constructors
   * @since 2.10.0
   */

  var separated = function separated(left, right) {
    return {
      left: left,
      right: right
    };
  };

  exports.separated = separated; // -------------------------------------------------------------------------------------
  // non-pipeables
  // -------------------------------------------------------------------------------------

  var _map = function _map(fa, f) {
    return function_1.pipe(fa, exports.map(f));
  };

  var _mapLeft = function _mapLeft(fa, f) {
    return function_1.pipe(fa, exports.mapLeft(f));
  };

  var _bimap = function _bimap(fa, g, f) {
    return function_1.pipe(fa, exports.bimap(g, f));
  }; // -------------------------------------------------------------------------------------
  // type class members
  // -------------------------------------------------------------------------------------

  /**
   * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
   * use the type constructor `F` to represent some computational context.
   *
   * @category Functor
   * @since 2.10.0
   */


  var map = function map(f) {
    return function (fa) {
      return exports.separated(exports.left(fa), f(exports.right(fa)));
    };
  };

  exports.map = map;
  /**
   * Map a function over the first type argument of a bifunctor.
   *
   * @category Bifunctor
   * @since 2.10.0
   */

  var mapLeft = function mapLeft(f) {
    return function (fa) {
      return exports.separated(f(exports.left(fa)), exports.right(fa));
    };
  };

  exports.mapLeft = mapLeft;
  /**
   * Map a pair of functions over the two type arguments of the bifunctor.
   *
   * @category Bifunctor
   * @since 2.10.0
   */

  var bimap = function bimap(f, g) {
    return function (fa) {
      return exports.separated(f(exports.left(fa)), g(exports.right(fa)));
    };
  };

  exports.bimap = bimap; // -------------------------------------------------------------------------------------
  // instances
  // -------------------------------------------------------------------------------------

  /**
   * @category instances
   * @since 2.10.0
   */

  exports.URI = 'Separated';
  /**
   * @category instances
   * @since 2.10.0
   */

  exports.Bifunctor = {
    URI: exports.URI,
    mapLeft: _mapLeft,
    bimap: _bimap
  };
  /**
   * @category instances
   * @since 2.10.0
   */

  exports.Functor = {
    URI: exports.URI,
    map: _map
  };
  /**
   * Derivable from `Functor`.
   *
   * @category combinators
   * @since 2.10.0
   */

  exports.flap =
  /*#_PURE_*/
  Functor_1.flap(exports.Functor); // -------------------------------------------------------------------------------------
  // utils
  // -------------------------------------------------------------------------------------

  /**
   * @since 2.10.0
   */

  var left = function left(s) {
    return s.left;
  };

  exports.left = left;
  /**
   * @since 2.10.0
   */

  var right = function right(s) {
    return s.right;
  };

  exports.right = right;
})(Separated);

var Witherable = {};

var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(Witherable, "__esModule", {
  value: true
});
Witherable.filterE = Witherable.witherDefault = Witherable.wiltDefault = void 0;

var _ = __importStar(internal);

function wiltDefault(T, C) {
  return function (F) {
    var traverseF = T.traverse(F);
    return function (wa, f) {
      return F.map(traverseF(wa, f), C.separate);
    };
  };
}

Witherable.wiltDefault = wiltDefault;

function witherDefault(T, C) {
  return function (F) {
    var traverseF = T.traverse(F);
    return function (wa, f) {
      return F.map(traverseF(wa, f), C.compact);
    };
  };
}

Witherable.witherDefault = witherDefault;

function filterE(W) {
  return function (F) {
    var witherF = W.wither(F);
    return function (predicate) {
      return function (ga) {
        return witherF(ga, function (a) {
          return F.map(predicate(a), function (b) {
            return b ? _.some(a) : _.none;
          });
        });
      };
    };
  };
}

Witherable.filterE = filterE;

(function (exports) {
  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    });
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });

  var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });

  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) {
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }

    __setModuleDefault(result, mod);

    return result;
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.fold = exports.match = exports.foldW = exports.matchW = exports.isRight = exports.isLeft = exports.fromOption = exports.fromPredicate = exports.FromEither = exports.MonadThrow = exports.throwError = exports.ChainRec = exports.Extend = exports.extend = exports.Alt = exports.alt = exports.altW = exports.Bifunctor = exports.mapLeft = exports.bimap = exports.Traversable = exports.sequence = exports.traverse = exports.Foldable = exports.reduceRight = exports.foldMap = exports.reduce = exports.Monad = exports.Chain = exports.chain = exports.chainW = exports.Applicative = exports.Apply = exports.ap = exports.apW = exports.Pointed = exports.of = exports.Functor = exports.map = exports.getAltValidation = exports.getApplicativeValidation = exports.getWitherable = exports.getFilterable = exports.getCompactable = exports.getSemigroup = exports.getEq = exports.getShow = exports.URI = exports.right = exports.left = void 0;
  exports.getValidation = exports.getValidationMonoid = exports.getValidationSemigroup = exports.getApplyMonoid = exports.getApplySemigroup = exports.either = exports.stringifyJSON = exports.parseJSON = exports.sequenceArray = exports.traverseArray = exports.traverseArrayWithIndex = exports.traverseReadonlyArrayWithIndex = exports.traverseReadonlyNonEmptyArrayWithIndex = exports.ApT = exports.apSW = exports.apS = exports.bindW = exports.bind = exports.bindTo = exports.Do = exports.exists = exports.elem = exports.toError = exports.toUnion = exports.chainNullableK = exports.fromNullableK = exports.tryCatchK = exports.tryCatch = exports.fromNullable = exports.orElse = exports.orElseW = exports.swap = exports.filterOrElseW = exports.filterOrElse = exports.chainOptionK = exports.fromOptionK = exports.duplicate = exports.flatten = exports.flattenW = exports.chainFirstW = exports.chainFirst = exports.apSecond = exports.apFirst = exports.flap = exports.getOrElse = exports.getOrElseW = void 0;
  var Applicative_1 = Applicative;
  var Apply_1 = Apply;
  var Chain_1 = Chain;
  var ChainRec_1 = ChainRec;
  var FromEither_1 = FromEither;
  var function_1 = _function;
  var Functor_1 = Functor;

  var _ = __importStar(internal);

  var Separated_1 = Separated;
  var Witherable_1 = Witherable; // -------------------------------------------------------------------------------------
  // constructors
  // -------------------------------------------------------------------------------------

  /**
   * Constructs a new `Either` holding a `Left` value. This usually represents a failure, due to the right-bias of this
   * structure.
   *
   * @category constructors
   * @since 2.0.0
   */

  exports.left = _.left;
  /**
   * Constructs a new `Either` holding a `Right` value. This usually represents a successful value due to the right bias
   * of this structure.
   *
   * @category constructors
   * @since 2.0.0
   */

  exports.right = _.right; // -------------------------------------------------------------------------------------
  // non-pipeables
  // -------------------------------------------------------------------------------------

  var _map = function _map(fa, f) {
    return function_1.pipe(fa, exports.map(f));
  };

  var _ap = function _ap(fab, fa) {
    return function_1.pipe(fab, exports.ap(fa));
  };
  /* istanbul ignore next */


  var _chain = function _chain(ma, f) {
    return function_1.pipe(ma, exports.chain(f));
  };
  /* istanbul ignore next */


  var _reduce = function _reduce(fa, b, f) {
    return function_1.pipe(fa, exports.reduce(b, f));
  };
  /* istanbul ignore next */


  var _foldMap = function _foldMap(M) {
    return function (fa, f) {
      var foldMapM = exports.foldMap(M);
      return function_1.pipe(fa, foldMapM(f));
    };
  };
  /* istanbul ignore next */


  var _reduceRight = function _reduceRight(fa, b, f) {
    return function_1.pipe(fa, exports.reduceRight(b, f));
  };

  var _traverse = function _traverse(F) {
    var traverseF = exports.traverse(F);
    return function (ta, f) {
      return function_1.pipe(ta, traverseF(f));
    };
  };

  var _bimap = function _bimap(fa, f, g) {
    return function_1.pipe(fa, exports.bimap(f, g));
  };

  var _mapLeft = function _mapLeft(fa, f) {
    return function_1.pipe(fa, exports.mapLeft(f));
  };
  /* istanbul ignore next */


  var _alt = function _alt(fa, that) {
    return function_1.pipe(fa, exports.alt(that));
  };
  /* istanbul ignore next */


  var _extend = function _extend(wa, f) {
    return function_1.pipe(wa, exports.extend(f));
  };

  var _chainRec = function _chainRec(a, f) {
    return ChainRec_1.tailRec(f(a), function (e) {
      return exports.isLeft(e) ? exports.right(exports.left(e.left)) : exports.isLeft(e.right) ? exports.left(f(e.right.left)) : exports.right(exports.right(e.right.right));
    });
  }; // -------------------------------------------------------------------------------------
  // instances
  // -------------------------------------------------------------------------------------

  /**
   * @category instances
   * @since 2.0.0
   */


  exports.URI = 'Either';
  /**
   * @category instances
   * @since 2.0.0
   */

  var getShow = function getShow(SE, SA) {
    return {
      show: function show(ma) {
        return exports.isLeft(ma) ? "left(" + SE.show(ma.left) + ")" : "right(" + SA.show(ma.right) + ")";
      }
    };
  };

  exports.getShow = getShow;
  /**
   * @category instances
   * @since 2.0.0
   */

  var getEq = function getEq(EL, EA) {
    return {
      equals: function equals(x, y) {
        return x === y || (exports.isLeft(x) ? exports.isLeft(y) && EL.equals(x.left, y.left) : exports.isRight(y) && EA.equals(x.right, y.right));
      }
    };
  };

  exports.getEq = getEq;
  /**
   * Semigroup returning the left-most non-`Left` value. If both operands are `Right`s then the inner values are
   * concatenated using the provided `Semigroup`
   *
   * @example
   * import { getSemigroup, left, right } from 'fp-ts/Either'
   * import { SemigroupSum } from 'fp-ts/number'
   *
   * const S = getSemigroup<string, number>(SemigroupSum)
   * assert.deepStrictEqual(S.concat(left('a'), left('b')), left('a'))
   * assert.deepStrictEqual(S.concat(left('a'), right(2)), right(2))
   * assert.deepStrictEqual(S.concat(right(1), left('b')), right(1))
   * assert.deepStrictEqual(S.concat(right(1), right(2)), right(3))
   *
   * @category instances
   * @since 2.0.0
   */

  var getSemigroup = function getSemigroup(S) {
    return {
      concat: function concat(x, y) {
        return exports.isLeft(y) ? x : exports.isLeft(x) ? y : exports.right(S.concat(x.right, y.right));
      }
    };
  };

  exports.getSemigroup = getSemigroup;
  /**
   * Builds a `Compactable` instance for `Either` given `Monoid` for the left side.
   *
   * @category instances
   * @since 2.10.0
   */

  var getCompactable = function getCompactable(M) {
    var empty = exports.left(M.empty);
    return {
      URI: exports.URI,
      _E: undefined,
      compact: function compact(ma) {
        return exports.isLeft(ma) ? ma : ma.right._tag === 'None' ? empty : exports.right(ma.right.value);
      },
      separate: function separate(ma) {
        return exports.isLeft(ma) ? Separated_1.separated(ma, ma) : exports.isLeft(ma.right) ? Separated_1.separated(exports.right(ma.right.left), empty) : Separated_1.separated(empty, exports.right(ma.right.right));
      }
    };
  };

  exports.getCompactable = getCompactable;
  /**
   * Builds a `Filterable` instance for `Either` given `Monoid` for the left side
   *
   * @category instances
   * @since 2.10.0
   */

  var getFilterable = function getFilterable(M) {
    var empty = exports.left(M.empty);

    var _a = exports.getCompactable(M),
        compact = _a.compact,
        separate = _a.separate;

    var filter = function filter(ma, predicate) {
      return exports.isLeft(ma) ? ma : predicate(ma.right) ? ma : empty;
    };

    var partition = function partition(ma, p) {
      return exports.isLeft(ma) ? Separated_1.separated(ma, ma) : p(ma.right) ? Separated_1.separated(empty, exports.right(ma.right)) : Separated_1.separated(exports.right(ma.right), empty);
    };

    return {
      URI: exports.URI,
      _E: undefined,
      map: _map,
      compact: compact,
      separate: separate,
      filter: filter,
      filterMap: function filterMap(ma, f) {
        if (exports.isLeft(ma)) {
          return ma;
        }

        var ob = f(ma.right);
        return ob._tag === 'None' ? empty : exports.right(ob.value);
      },
      partition: partition,
      partitionMap: function partitionMap(ma, f) {
        if (exports.isLeft(ma)) {
          return Separated_1.separated(ma, ma);
        }

        var e = f(ma.right);
        return exports.isLeft(e) ? Separated_1.separated(exports.right(e.left), empty) : Separated_1.separated(empty, exports.right(e.right));
      }
    };
  };

  exports.getFilterable = getFilterable;
  /**
   * Builds `Witherable` instance for `Either` given `Monoid` for the left side
   *
   * @category instances
   * @since 2.0.0
   */

  var getWitherable = function getWitherable(M) {
    var F_ = exports.getFilterable(M);
    var C = exports.getCompactable(M);
    return {
      URI: exports.URI,
      _E: undefined,
      map: _map,
      compact: F_.compact,
      separate: F_.separate,
      filter: F_.filter,
      filterMap: F_.filterMap,
      partition: F_.partition,
      partitionMap: F_.partitionMap,
      traverse: _traverse,
      sequence: exports.sequence,
      reduce: _reduce,
      foldMap: _foldMap,
      reduceRight: _reduceRight,
      wither: Witherable_1.witherDefault(exports.Traversable, C),
      wilt: Witherable_1.wiltDefault(exports.Traversable, C)
    };
  };

  exports.getWitherable = getWitherable;
  /**
   * @category instances
   * @since 2.7.0
   */

  var getApplicativeValidation = function getApplicativeValidation(SE) {
    return {
      URI: exports.URI,
      _E: undefined,
      map: _map,
      ap: function ap(fab, fa) {
        return exports.isLeft(fab) ? exports.isLeft(fa) ? exports.left(SE.concat(fab.left, fa.left)) : fab : exports.isLeft(fa) ? fa : exports.right(fab.right(fa.right));
      },
      of: exports.of
    };
  };

  exports.getApplicativeValidation = getApplicativeValidation;
  /**
   * @category instances
   * @since 2.7.0
   */

  var getAltValidation = function getAltValidation(SE) {
    return {
      URI: exports.URI,
      _E: undefined,
      map: _map,
      alt: function alt(me, that) {
        if (exports.isRight(me)) {
          return me;
        }

        var ea = that();
        return exports.isLeft(ea) ? exports.left(SE.concat(me.left, ea.left)) : ea;
      }
    };
  };

  exports.getAltValidation = getAltValidation;
  /**
   * @category instance operations
   * @since 2.0.0
   */

  var map = function map(f) {
    return function (fa) {
      return exports.isLeft(fa) ? fa : exports.right(f(fa.right));
    };
  };

  exports.map = map;
  /**
   * @category instances
   * @since 2.7.0
   */

  exports.Functor = {
    URI: exports.URI,
    map: _map
  };
  /**
   * @category instance operations
   * @since 2.7.0
   */

  exports.of = exports.right;
  /**
   * @category instances
   * @since 2.10.0
   */

  exports.Pointed = {
    URI: exports.URI,
    of: exports.of
  };
  /**
   * Less strict version of [`ap`](#ap).
   *
   * @category instance operations
   * @since 2.8.0
   */

  var apW = function apW(fa) {
    return function (fab) {
      return exports.isLeft(fab) ? fab : exports.isLeft(fa) ? fa : exports.right(fab.right(fa.right));
    };
  };

  exports.apW = apW;
  /**
   * Apply a function to an argument under a type constructor.
   *
   * @category instance operations
   * @since 2.0.0
   */

  exports.ap = exports.apW;
  /**
   * @category instances
   * @since 2.10.0
   */

  exports.Apply = {
    URI: exports.URI,
    map: _map,
    ap: _ap
  };
  /**
   * @category instances
   * @since 2.7.0
   */

  exports.Applicative = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of
  };
  /**
   * Less strict version of [`chain`](#chain).
   *
   * @category instance operations
   * @since 2.6.0
   */

  var chainW = function chainW(f) {
    return function (ma) {
      return exports.isLeft(ma) ? ma : f(ma.right);
    };
  };

  exports.chainW = chainW;
  /**
   * Composes computations in sequence, using the return value of one computation to determine the next computation.
   *
   * @category instance operations
   * @since 2.0.0
   */

  exports.chain = exports.chainW;
  /**
   * @category instances
   * @since 2.10.0
   */

  exports.Chain = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: _chain
  };
  /**
   * @category instances
   * @since 2.7.0
   */

  exports.Monad = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    chain: _chain
  };
  /**
   * Left-associative fold of a structure.
   *
   * @example
   * import { pipe } from 'fp-ts/function'
   * import * as E from 'fp-ts/Either'
   *
   * const startWith = 'prefix'
   * const concat = (a: string, b: string) => `${a}:${b}`
   *
   * assert.deepStrictEqual(
   *   pipe(E.right('a'), E.reduce(startWith, concat)),
   *   'prefix:a'
   * )
   *
   * assert.deepStrictEqual(
   *   pipe(E.left('e'), E.reduce(startWith, concat)),
   *   'prefix'
   * )
   *
   * @category instance operations
   * @since 2.0.0
   */

  var reduce = function reduce(b, f) {
    return function (fa) {
      return exports.isLeft(fa) ? b : f(b, fa.right);
    };
  };

  exports.reduce = reduce;
  /**
   * Map each element of the structure to a monoid, and combine the results.
   *
   * @example
   * import { pipe } from 'fp-ts/function'
   * import * as E from 'fp-ts/Either'
   * import * as S from 'fp-ts/string'
   *
   * const yell = (a: string) => `${a}!`
   *
   * assert.deepStrictEqual(
   *   pipe(E.right('a'), E.foldMap(S.Monoid)(yell)),
   *   'a!'
   * )
   *
   * assert.deepStrictEqual(
   *   pipe(E.left('e'), E.foldMap(S.Monoid)(yell)),
   *   S.Monoid.empty
   * )
   *
   * @category instance operations
   * @since 2.0.0
   */

  var foldMap = function foldMap(M) {
    return function (f) {
      return function (fa) {
        return exports.isLeft(fa) ? M.empty : f(fa.right);
      };
    };
  };

  exports.foldMap = foldMap;
  /**
   * Right-associative fold of a structure.
   *
   * @example
   * import { pipe } from 'fp-ts/function'
   * import * as E from 'fp-ts/Either'
   *
   * const startWith = 'postfix'
   * const concat = (a: string, b: string) => `${a}:${b}`
   *
   * assert.deepStrictEqual(
   *   pipe(E.right('a'), E.reduceRight(startWith, concat)),
   *   'a:postfix'
   * )
   *
   * assert.deepStrictEqual(
   *   pipe(E.left('e'), E.reduceRight(startWith, concat)),
   *   'postfix'
   * )
   *
   * @category instance operations
   * @since 2.0.0
   */

  var reduceRight = function reduceRight(b, f) {
    return function (fa) {
      return exports.isLeft(fa) ? b : f(fa.right, b);
    };
  };

  exports.reduceRight = reduceRight;
  /**
   * @category instances
   * @since 2.7.0
   */

  exports.Foldable = {
    URI: exports.URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight
  };
  /**
   * Map each element of a structure to an action, evaluate these actions from left to right, and collect the results.
   *
   * @example
   * import { pipe } from 'fp-ts/function'
   * import * as RA from 'fp-ts/ReadonlyArray'
   * import * as E from 'fp-ts/Either'
   * import * as O from 'fp-ts/Option'
   *
   * assert.deepStrictEqual(
   *   pipe(E.right(['a']), E.traverse(O.Applicative)(RA.head)),
   *   O.some(E.right('a'))
   *  )
   *
   * assert.deepStrictEqual(
   *   pipe(E.right([]), E.traverse(O.Applicative)(RA.head)),
   *   O.none
   * )
   *
   * @category instance operations
   * @since 2.6.3
   */

  var traverse = function traverse(F) {
    return function (f) {
      return function (ta) {
        return exports.isLeft(ta) ? F.of(exports.left(ta.left)) : F.map(f(ta.right), exports.right);
      };
    };
  };

  exports.traverse = traverse;
  /**
   * Evaluate each monadic action in the structure from left to right, and collect the results.
   *
   * @example
   * import { pipe } from 'fp-ts/function'
   * import * as E from 'fp-ts/Either'
   * import * as O from 'fp-ts/Option'
   *
   * assert.deepStrictEqual(
   *   pipe(E.right(O.some('a')), E.sequence(O.Applicative)),
   *   O.some(E.right('a'))
   *  )
   *
   * assert.deepStrictEqual(
   *   pipe(E.right(O.none), E.sequence(O.Applicative)),
   *   O.none
   * )
   *
   * @category instance operations
   * @since 2.6.3
   */

  var sequence = function sequence(F) {
    return function (ma) {
      return exports.isLeft(ma) ? F.of(exports.left(ma.left)) : F.map(ma.right, exports.right);
    };
  };

  exports.sequence = sequence;
  /**
   * @category instances
   * @since 2.7.0
   */

  exports.Traversable = {
    URI: exports.URI,
    map: _map,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence
  };
  /**
   * Map a pair of functions over the two type arguments of the bifunctor.
   *
   * @category instance operations
   * @since 2.0.0
   */

  var bimap = function bimap(f, g) {
    return function (fa) {
      return exports.isLeft(fa) ? exports.left(f(fa.left)) : exports.right(g(fa.right));
    };
  };

  exports.bimap = bimap;
  /**
   * Map a function over the first type argument of a bifunctor.
   *
   * @category instance operations
   * @since 2.0.0
   */

  var mapLeft = function mapLeft(f) {
    return function (fa) {
      return exports.isLeft(fa) ? exports.left(f(fa.left)) : fa;
    };
  };

  exports.mapLeft = mapLeft;
  /**
   * @category instances
   * @since 2.7.0
   */

  exports.Bifunctor = {
    URI: exports.URI,
    bimap: _bimap,
    mapLeft: _mapLeft
  };
  /**
   * Less strict version of [`alt`](#alt).
   *
   * @category instance operations
   * @since 2.9.0
   */

  var altW = function altW(that) {
    return function (fa) {
      return exports.isLeft(fa) ? that() : fa;
    };
  };

  exports.altW = altW;
  /**
   * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
   * types of kind `* -> *`.
   *
   * @category instance operations
   * @since 2.0.0
   */

  exports.alt = exports.altW;
  /**
   * @category instances
   * @since 2.7.0
   */

  exports.Alt = {
    URI: exports.URI,
    map: _map,
    alt: _alt
  };
  /**
   * @category instance operations
   * @since 2.0.0
   */

  var extend = function extend(f) {
    return function (wa) {
      return exports.isLeft(wa) ? wa : exports.right(f(wa));
    };
  };

  exports.extend = extend;
  /**
   * @category instances
   * @since 2.7.0
   */

  exports.Extend = {
    URI: exports.URI,
    map: _map,
    extend: _extend
  };
  /**
   * @category instances
   * @since 2.7.0
   */

  exports.ChainRec = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: _chain,
    chainRec: _chainRec
  };
  /**
   * @category instance operations
   * @since 2.6.3
   */

  exports.throwError = exports.left;
  /**
   * @category instances
   * @since 2.7.0
   */

  exports.MonadThrow = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    chain: _chain,
    throwError: exports.throwError
  };
  /**
   * @category instances
   * @since 2.10.0
   */

  exports.FromEither = {
    URI: exports.URI,
    fromEither: function_1.identity
  };
  /**
   * @example
   * import { fromPredicate, left, right } from 'fp-ts/Either'
   * import { pipe } from 'fp-ts/function'
   *
   * assert.deepStrictEqual(
   *   pipe(
   *     1,
   *     fromPredicate(
   *       (n) => n > 0,
   *       () => 'error'
   *     )
   *   ),
   *   right(1)
   * )
   * assert.deepStrictEqual(
   *   pipe(
   *     -1,
   *     fromPredicate(
   *       (n) => n > 0,
   *       () => 'error'
   *     )
   *   ),
   *   left('error')
   * )
   *
   * @category constructors
   * @since 2.0.0
   */

  exports.fromPredicate = /*#__PURE__*/FromEither_1.fromPredicate(exports.FromEither); // -------------------------------------------------------------------------------------
  // natural transformations
  // -------------------------------------------------------------------------------------

  /**
   * @example
   * import * as E from 'fp-ts/Either'
   * import { pipe } from 'fp-ts/function'
   * import * as O from 'fp-ts/Option'
   *
   * assert.deepStrictEqual(
   *   pipe(
   *     O.some(1),
   *     E.fromOption(() => 'error')
   *   ),
   *   E.right(1)
   * )
   * assert.deepStrictEqual(
   *   pipe(
   *     O.none,
   *     E.fromOption(() => 'error')
   *   ),
   *   E.left('error')
   * )
   *
   * @category natural transformations
   * @since 2.0.0
   */

  exports.fromOption = /*#__PURE__*/FromEither_1.fromOption(exports.FromEither); // -------------------------------------------------------------------------------------
  // refinements
  // -------------------------------------------------------------------------------------

  /**
   * Returns `true` if the either is an instance of `Left`, `false` otherwise.
   *
   * @category refinements
   * @since 2.0.0
   */

  exports.isLeft = _.isLeft;
  /**
   * Returns `true` if the either is an instance of `Right`, `false` otherwise.
   *
   * @category refinements
   * @since 2.0.0
   */

  exports.isRight = _.isRight; // -------------------------------------------------------------------------------------
  // destructors
  // -------------------------------------------------------------------------------------

  /**
   * Less strict version of [`match`](#match).
   *
   * @category destructors
   * @since 2.10.0
   */

  var matchW = function matchW(onLeft, onRight) {
    return function (ma) {
      return exports.isLeft(ma) ? onLeft(ma.left) : onRight(ma.right);
    };
  };

  exports.matchW = matchW;
  /**
   * Alias of [`matchW`](#matchw).
   *
   * @category destructors
   * @since 2.10.0
   */

  exports.foldW = exports.matchW;
  /**
   * Takes two functions and an `Either` value, if the value is a `Left` the inner value is applied to the first function,
   * if the value is a `Right` the inner value is applied to the second function.
   *
   * @example
   * import { match, left, right } from 'fp-ts/Either'
   * import { pipe } from 'fp-ts/function'
   *
   * function onLeft(errors: Array<string>): string {
   *   return `Errors: ${errors.join(', ')}`
   * }
   *
   * function onRight(value: number): string {
   *   return `Ok: ${value}`
   * }
   *
   * assert.strictEqual(
   *   pipe(
   *     right(1),
   *     match(onLeft, onRight)
   *   ),
   *   'Ok: 1'
   * )
   * assert.strictEqual(
   *   pipe(
   *     left(['error 1', 'error 2']),
   *     match(onLeft, onRight)
   *   ),
   *   'Errors: error 1, error 2'
   * )
   *
   * @category destructors
   * @since 2.10.0
   */

  exports.match = exports.matchW;
  /**
   * Alias of [`match`](#match).
   *
   * @category destructors
   * @since 2.0.0
   */

  exports.fold = exports.match;
  /**
   * Less strict version of [`getOrElse`](#getorelse).
   *
   * @category destructors
   * @since 2.6.0
   */

  var getOrElseW = function getOrElseW(onLeft) {
    return function (ma) {
      return exports.isLeft(ma) ? onLeft(ma.left) : ma.right;
    };
  };

  exports.getOrElseW = getOrElseW;
  /**
   * Returns the wrapped value if it's a `Right` or a default value if is a `Left`.
   *
   * @example
   * import { getOrElse, left, right } from 'fp-ts/Either'
   * import { pipe } from 'fp-ts/function'
   *
   * assert.deepStrictEqual(
   *   pipe(
   *     right(1),
   *     getOrElse(() => 0)
   *   ),
   *   1
   * )
   * assert.deepStrictEqual(
   *   pipe(
   *     left('error'),
   *     getOrElse(() => 0)
   *   ),
   *   0
   * )
   *
   * @category destructors
   * @since 2.0.0
   */

  exports.getOrElse = exports.getOrElseW; // -------------------------------------------------------------------------------------
  // combinators
  // -------------------------------------------------------------------------------------

  /**
   * Derivable from `Functor`.
   *
   * @category combinators
   * @since 2.10.0
   */

  exports.flap =
  /*#_PURE_*/
  Functor_1.flap(exports.Functor);
  /**
   * Combine two effectful actions, keeping only the result of the first.
   *
   * Derivable from `Apply`.
   *
   * @category combinators
   * @since 2.0.0
   */

  exports.apFirst = /*#__PURE__*/Apply_1.apFirst(exports.Apply);
  /**
   * Combine two effectful actions, keeping only the result of the second.
   *
   * Derivable from `Apply`.
   *
   * @category combinators
   * @since 2.0.0
   */

  exports.apSecond = /*#__PURE__*/Apply_1.apSecond(exports.Apply);
  /**
   * Composes computations in sequence, using the return value of one computation to determine the next computation and
   * keeping only the result of the first.
   *
   * Derivable from `Chain`.
   *
   * @category combinators
   * @since 2.0.0
   */

  exports.chainFirst = /*#__PURE__*/Chain_1.chainFirst(exports.Chain);
  /**
   * Less strict version of [`chainFirst`](#chainfirst)
   *
   * Derivable from `Chain`.
   *
   * @category combinators
   * @since 2.8.0
   */

  exports.chainFirstW = exports.chainFirst;
  /**
   * Less strict version of [`flatten`](#flatten).
   *
   * @category combinators
   * @since 2.11.0
   */

  exports.flattenW = /*#__PURE__*/exports.chainW(function_1.identity);
  /**
   * The `flatten` function is the conventional monad join operator. It is used to remove one level of monadic structure, projecting its bound argument into the outer level.
   *
   * Derivable from `Chain`.
   *
   * @example
   * import * as E from 'fp-ts/Either'
   *
   * assert.deepStrictEqual(E.flatten(E.right(E.right('a'))), E.right('a'))
   * assert.deepStrictEqual(E.flatten(E.right(E.left('e'))), E.left('e'))
   * assert.deepStrictEqual(E.flatten(E.left('e')), E.left('e'))
   *
   * @category combinators
   * @since 2.0.0
   */

  exports.flatten = exports.flattenW;
  /**
   * Derivable from `Extend`.
   *
   * @category combinators
   * @since 2.0.0
   */

  exports.duplicate = /*#__PURE__*/exports.extend(function_1.identity);
  /**
   * @category combinators
   * @since 2.10.0
   */

  exports.fromOptionK = /*#__PURE__*/FromEither_1.fromOptionK(exports.FromEither);
  /**
   * @category combinators
   * @since 2.11.0
   */

  exports.chainOptionK = /*#__PURE__*/FromEither_1.chainOptionK(exports.FromEither, exports.Chain);
  /**
   * @example
   * import * as E from 'fp-ts/Either'
   * import { pipe } from 'fp-ts/function'
   *
   * assert.deepStrictEqual(
   *   pipe(
   *     E.right(1),
   *     E.filterOrElse(
   *       (n) => n > 0,
   *       () => 'error'
   *     )
   *   ),
   *   E.right(1)
   * )
   * assert.deepStrictEqual(
   *   pipe(
   *     E.right(-1),
   *     E.filterOrElse(
   *       (n) => n > 0,
   *       () => 'error'
   *     )
   *   ),
   *   E.left('error')
   * )
   * assert.deepStrictEqual(
   *   pipe(
   *     E.left('a'),
   *     E.filterOrElse(
   *       (n) => n > 0,
   *       () => 'error'
   *     )
   *   ),
   *   E.left('a')
   * )
   *
   * @category combinators
   * @since 2.0.0
   */

  exports.filterOrElse = /*#__PURE__*/FromEither_1.filterOrElse(exports.FromEither, exports.Chain);
  /**
   * Less strict version of [`filterOrElse`](#filterorelse).
   *
   * @category combinators
   * @since 2.9.0
   */

  exports.filterOrElseW = exports.filterOrElse;
  /**
   * Returns a `Right` if is a `Left` (and vice versa).
   *
   * @category combinators
   * @since 2.0.0
   */

  var swap = function swap(ma) {
    return exports.isLeft(ma) ? exports.right(ma.left) : exports.left(ma.right);
  };

  exports.swap = swap;
  /**
   * Less strict version of [`orElse`](#orelse).
   *
   * @category combinators
   * @since 2.10.0
   */

  var orElseW = function orElseW(onLeft) {
    return function (ma) {
      return exports.isLeft(ma) ? onLeft(ma.left) : ma;
    };
  };

  exports.orElseW = orElseW;
  /**
   * Useful for recovering from errors.
   *
   * @category combinators
   * @since 2.0.0
   */

  exports.orElse = exports.orElseW; // -------------------------------------------------------------------------------------
  // interop
  // -------------------------------------------------------------------------------------

  /**
   * Takes a default and a nullable value, if the value is not nully, turn it into a `Right`, if the value is nully use
   * the provided default as a `Left`.
   *
   * @example
   * import { fromNullable, left, right } from 'fp-ts/Either'
   *
   * const parse = fromNullable('nully')
   *
   * assert.deepStrictEqual(parse(1), right(1))
   * assert.deepStrictEqual(parse(null), left('nully'))
   *
   * @category interop
   * @since 2.0.0
   */

  var fromNullable = function fromNullable(e) {
    return function (a) {
      return a == null ? exports.left(e) : exports.right(a);
    };
  };

  exports.fromNullable = fromNullable;
  /**
   * Constructs a new `Either` from a function that might throw.
   *
   * See also [`tryCatchK`](#trycatchk).
   *
   * @example
   * import * as E from 'fp-ts/Either'
   *
   * const unsafeHead = <A>(as: ReadonlyArray<A>): A => {
   *   if (as.length > 0) {
   *     return as[0]
   *   } else {
   *     throw new Error('empty array')
   *   }
   * }
   *
   * const head = <A>(as: ReadonlyArray<A>): E.Either<Error, A> =>
   *   E.tryCatch(() => unsafeHead(as), e => (e instanceof Error ? e : new Error('unknown error')))
   *
   * assert.deepStrictEqual(head([]), E.left(new Error('empty array')))
   * assert.deepStrictEqual(head([1, 2, 3]), E.right(1))
   *
   * @category interop
   * @since 2.0.0
   */

  var tryCatch = function tryCatch(f, onThrow) {
    try {
      return exports.right(f());
    } catch (e) {
      return exports.left(onThrow(e));
    }
  };

  exports.tryCatch = tryCatch;
  /**
   * Converts a function that may throw to one returning a `Either`.
   *
   * @category interop
   * @since 2.10.0
   */

  var tryCatchK = function tryCatchK(f, onThrow) {
    return function () {
      var a = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
      }

      return exports.tryCatch(function () {
        return f.apply(void 0, a);
      }, onThrow);
    };
  };

  exports.tryCatchK = tryCatchK;
  /**
   * @category interop
   * @since 2.9.0
   */

  var fromNullableK = function fromNullableK(e) {
    var from = exports.fromNullable(e);
    return function (f) {
      return function_1.flow(f, from);
    };
  };

  exports.fromNullableK = fromNullableK;
  /**
   * @category interop
   * @since 2.9.0
   */

  var chainNullableK = function chainNullableK(e) {
    var from = exports.fromNullableK(e);
    return function (f) {
      return exports.chain(from(f));
    };
  };

  exports.chainNullableK = chainNullableK;
  /**
   * @category interop
   * @since 2.10.0
   */

  exports.toUnion = /*#__PURE__*/exports.foldW(function_1.identity, function_1.identity); // -------------------------------------------------------------------------------------
  // utils
  // -------------------------------------------------------------------------------------

  /**
   * Default value for the `onError` argument of `tryCatch`
   *
   * @since 2.0.0
   */

  function toError(e) {
    return e instanceof Error ? e : new Error(String(e));
  }

  exports.toError = toError;
  /**
   * @since 2.0.0
   */

  var elem = function elem(E) {
    return function (a, ma) {
      return exports.isLeft(ma) ? false : E.equals(a, ma.right);
    };
  };

  exports.elem = elem;
  /**
   * Returns `false` if `Left` or returns the result of the application of the given predicate to the `Right` value.
   *
   * @example
   * import { exists, left, right } from 'fp-ts/Either'
   *
   * const gt2 = exists((n: number) => n > 2)
   *
   * assert.strictEqual(gt2(left('a')), false)
   * assert.strictEqual(gt2(right(1)), false)
   * assert.strictEqual(gt2(right(3)), true)
   *
   * @since 2.0.0
   */

  var exists = function exists(predicate) {
    return function (ma) {
      return exports.isLeft(ma) ? false : predicate(ma.right);
    };
  };

  exports.exists = exists; // -------------------------------------------------------------------------------------
  // do notation
  // -------------------------------------------------------------------------------------

  /**
   * @since 2.9.0
   */

  exports.Do = /*#__PURE__*/exports.of(_.emptyRecord);
  /**
   * @since 2.8.0
   */

  exports.bindTo = /*#__PURE__*/Functor_1.bindTo(exports.Functor);
  /**
   * @since 2.8.0
   */

  exports.bind = /*#__PURE__*/Chain_1.bind(exports.Chain);
  /**
   * @since 2.8.0
   */

  exports.bindW = exports.bind; // -------------------------------------------------------------------------------------
  // pipeable sequence S
  // -------------------------------------------------------------------------------------

  /**
   * @since 2.8.0
   */

  exports.apS = /*#__PURE__*/Apply_1.apS(exports.Apply);
  /**
   * @since 2.8.0
   */

  exports.apSW = exports.apS; // -------------------------------------------------------------------------------------
  // sequence T
  // -------------------------------------------------------------------------------------

  /**
   * @since 2.11.0
   */

  exports.ApT = exports.of(_.emptyReadonlyArray); // -------------------------------------------------------------------------------------
  // array utils
  // -------------------------------------------------------------------------------------

  /**
   * Equivalent to `ReadonlyNonEmptyArray#traverseWithIndex(Applicative)`.
   *
   * @since 2.11.0
   */

  var traverseReadonlyNonEmptyArrayWithIndex = function traverseReadonlyNonEmptyArrayWithIndex(f) {
    return function (as) {
      var e = f(0, _.head(as));

      if (exports.isLeft(e)) {
        return e;
      }

      var out = [e.right];

      for (var i = 1; i < as.length; i++) {
        var e_1 = f(i, as[i]);

        if (exports.isLeft(e_1)) {
          return e_1;
        }

        out.push(e_1.right);
      }

      return exports.right(out);
    };
  };

  exports.traverseReadonlyNonEmptyArrayWithIndex = traverseReadonlyNonEmptyArrayWithIndex;
  /**
   * Equivalent to `ReadonlyArray#traverseWithIndex(Applicative)`.
   *
   * @since 2.11.0
   */

  var traverseReadonlyArrayWithIndex = function traverseReadonlyArrayWithIndex(f) {
    var g = exports.traverseReadonlyNonEmptyArrayWithIndex(f);
    return function (as) {
      return _.isNonEmpty(as) ? g(as) : exports.ApT;
    };
  };

  exports.traverseReadonlyArrayWithIndex = traverseReadonlyArrayWithIndex;
  /**
   * @since 2.9.0
   */

  exports.traverseArrayWithIndex = exports.traverseReadonlyArrayWithIndex;
  /**
   * @since 2.9.0
   */

  var traverseArray = function traverseArray(f) {
    return exports.traverseReadonlyArrayWithIndex(function (_, a) {
      return f(a);
    });
  };

  exports.traverseArray = traverseArray;
  /**
   * @since 2.9.0
   */

  exports.sequenceArray = /*#__PURE__*/exports.traverseArray(function_1.identity);
  /**
   * Use [`parse`](./Json.ts.html#parse) instead.
   *
   * @category constructors
   * @since 2.0.0
   * @deprecated
   */

  function parseJSON(s, onError) {
    return exports.tryCatch(function () {
      return JSON.parse(s);
    }, onError);
  }

  exports.parseJSON = parseJSON;
  /**
   * Use [`stringify`](./Json.ts.html#stringify) instead.
   *
   * @category constructors
   * @since 2.0.0
   * @deprecated
   */

  var stringifyJSON = function stringifyJSON(u, onError) {
    return exports.tryCatch(function () {
      var s = JSON.stringify(u);

      if (typeof s !== 'string') {
        throw new Error('Converting unsupported structure to JSON');
      }

      return s;
    }, onError);
  };

  exports.stringifyJSON = stringifyJSON;
  /**
   * Use small, specific instances instead.
   *
   * @category instances
   * @since 2.0.0
   * @deprecated
   */

  exports.either = {
    URI: exports.URI,
    map: _map,
    of: exports.of,
    ap: _ap,
    chain: _chain,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence,
    bimap: _bimap,
    mapLeft: _mapLeft,
    alt: _alt,
    extend: _extend,
    chainRec: _chainRec,
    throwError: exports.throwError
  };
  /**
   * Use [`getApplySemigroup`](./Apply.ts.html#getapplysemigroup) instead.
   *
   * Semigroup returning the left-most `Left` value. If both operands are `Right`s then the inner values
   * are concatenated using the provided `Semigroup`
   *
   * @category instances
   * @since 2.0.0
   * @deprecated
   */

  exports.getApplySemigroup = /*#__PURE__*/Apply_1.getApplySemigroup(exports.Apply);
  /**
   * Use [`getApplicativeMonoid`](./Applicative.ts.html#getapplicativemonoid) instead.
   *
   * @category instances
   * @since 2.0.0
   * @deprecated
   */

  exports.getApplyMonoid = /*#__PURE__*/Applicative_1.getApplicativeMonoid(exports.Applicative);
  /**
   * Use [`getApplySemigroup`](./Apply.ts.html#getapplysemigroup) instead.
   *
   * @category instances
   * @since 2.0.0
   * @deprecated
   */

  var getValidationSemigroup = function getValidationSemigroup(SE, SA) {
    return Apply_1.getApplySemigroup(exports.getApplicativeValidation(SE))(SA);
  };

  exports.getValidationSemigroup = getValidationSemigroup;
  /**
   * Use [`getApplicativeMonoid`](./Applicative.ts.html#getapplicativemonoid) instead.
   *
   * @category instances
   * @since 2.0.0
   * @deprecated
   */

  var getValidationMonoid = function getValidationMonoid(SE, MA) {
    return Applicative_1.getApplicativeMonoid(exports.getApplicativeValidation(SE))(MA);
  };

  exports.getValidationMonoid = getValidationMonoid;
  /**
   * Use [`getApplicativeValidation`](#getapplicativevalidation) and [`getAltValidation`](#getaltvalidation) instead.
   *
   * @category instances
   * @since 2.0.0
   * @deprecated
   */

  function getValidation(SE) {
    var ap = exports.getApplicativeValidation(SE).ap;
    var alt = exports.getAltValidation(SE).alt;
    return {
      URI: exports.URI,
      _E: undefined,
      map: _map,
      of: exports.of,
      chain: _chain,
      bimap: _bimap,
      mapLeft: _mapLeft,
      reduce: _reduce,
      foldMap: _foldMap,
      reduceRight: _reduceRight,
      extend: _extend,
      traverse: _traverse,
      sequence: exports.sequence,
      chainRec: _chainRec,
      throwError: exports.throwError,
      ap: ap,
      alt: alt
    };
  }

  exports.getValidation = getValidation;
})(Either);

var beeActions = {
  CREATE: 'create',
  START: 'start',
  LOAD: 'load',
  SAVE: 'save',
  SEND: 'send',
  PREVIEW: 'preview',
  SAVE_AS_TEMPLATE: 'saveAsTemplate',
  TOGGLE_STRUCTURE: 'toggleStructure',
  TOGGLE_COMMENTS: 'toggleComments',
  TOGGLE_PREVIEW: 'togglePreview',
  TOGGLE_MERGETAGS_PREVIEW: 'toggleMergeTagsPreview',
  SHOW_COMMENT: 'showComment',
  JOIN: 'join',
  RELOAD: 'reload',
  LOAD_WORKSPACE: 'loadWorkspace',
  LOAD_STAGE_MODE: 'loadStageMode',
  LOAD_CONFIG: 'loadConfig'
};
var axios$2 = {
  exports: {}
};

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    return fn.apply(thisArg, args);
  };
};

var bind$1 = bind$2; // utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */

function isArray(val) {
  return toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */


function isUndefined(val) {
  return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */


function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */


function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */


function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */


function isArrayBufferView(val) {
  var result;

  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }

  return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */


function isString(val) {
  return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */


function isNumber(val) {
  return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */


function isObject(val) {
  return val !== null && _typeof(val) === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */


function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */


function isDate(val) {
  return toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */


function isFile(val) {
  return toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */


function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */


function isFunction(val) {
  return toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */


function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */


function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */


function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */


function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */


function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  } // Force an array if not already something iterable


  if (_typeof(obj) !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */


function merge() {
  var result = {};

  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }

  return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */


function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */


function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }

  return content;
}

var utils$d = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};
var utils$c = utils$d;

function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */


var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;

  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$c.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$c.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$c.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$c.forEach(val, function parseValue(v) {
        if (utils$c.isDate(v)) {
          v = v.toISOString();
        } else if (utils$c.isObject(v)) {
          v = JSON.stringify(v);
        }

        parts.push(encode(key) + '=' + encode(v));
      });
    });
    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$b = utils$d;

function InterceptorManager$1() {
  this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */


InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */


InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */


InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$b.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;
var utils$a = utils$d;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$a.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */


var enhanceError$2 = function enhanceError(error, config, code, request, response) {
  error.config = config;

  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };

  return error;
};

var enhanceError$1 = enhanceError$2;
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */

var createError$2 = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError$1(error, config, code, request, response);
};

var createError$1 = createError$2;
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */

var settle$1 = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;

  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError$1('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

var utils$9 = utils$d;
var cookies$1 = utils$9.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils$9.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils$9.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils$9.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */


var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */

var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }

  return requestedURL;
};

var utils$8 = utils$d; // Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers

var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */

var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils$8.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$8.trim(line.substr(0, i)).toLowerCase();
    val = utils$8.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }

      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

var utils$7 = utils$d;
var isURLSameOrigin$1 = utils$7.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;
  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */

  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);
  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */

  return function isURLSameOrigin(requestURL) {
    var parsed = utils$7.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel$3(message) {
  this.message = message;
}

Cancel$3.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel$3.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$3;
var utils$6 = utils$d;
var settle = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath = buildFullPath$1;
var parseHeaders = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError = createError$2;
var defaults$4 = defaults_1;
var Cancel$2 = Cancel_1;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;

    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils$6.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest(); // HTTP basic authentication

    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      } // Prepare the response


      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response); // Clean up request

      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        } // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request


        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        } // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'


        setTimeout(onloadend);
      };
    } // Handle browser request cancellation (as opposed to a manual cancellation)


    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

      request = null;
    }; // Handle low level network errors


    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request)); // Clean up request

      request = null;
    }; // Handle timeout


    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults$4.transitional;

      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }

      reject(createError(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request)); // Clean up request

      request = null;
    }; // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.


    if (utils$6.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    } // Add headers to the request


    if ('setRequestHeader' in request) {
      utils$6.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    } // Add withCredentials to request if needed


    if (!utils$6.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    } // Add responseType to request if needed


    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    } // Handle progress if needed


    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    } // Not all browsers support upload events


    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function onCanceled(cancel) {
        if (!request) {
          return;
        }

        reject(!cancel || cancel && cancel.type ? new Cancel$2('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);

      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    } // Send the request


    request.send(requestData);
  });
};

var utils$5 = utils$d;
var normalizeHeaderName = normalizeHeaderName$1;
var enhanceError = enhanceError$2;
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;

  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }

  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$5.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$5.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$3 = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$5.isFormData(data) || utils$5.isArrayBuffer(data) || utils$5.isBuffer(data) || utils$5.isStream(data) || utils$5.isFile(data) || utils$5.isBlob(data)) {
      return data;
    }

    if (utils$5.isArrayBufferView(data)) {
      return data.buffer;
    }

    if (utils$5.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    if (utils$5.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],
  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data) && data.length) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }

          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};
utils$5.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});
utils$5.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3;
var utils$4 = utils$d;
var defaults$2 = defaults_1;
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */

var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$2;
  /*eslint no-param-reassign:0*/

  utils$4.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });
  return data;
};

var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var utils$3 = utils$d;
var transformData = transformData$1;
var isCancel = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$1 = Cancel_1;
/**
 * Throws a `Cancel` if cancellation has been requested.
 */

function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel$1('canceled');
  }
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */


var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config); // Ensure headers exist

  config.headers = config.headers || {}; // Transform request data

  config.data = transformData.call(config, config.data, config.headers, config.transformRequest); // Flatten headers

  config.headers = utils$3.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$3.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults$1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config); // Transform response data

    response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config); // Transform response data

      if (reason && reason.response) {
        reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

var utils$2 = utils$d;
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */

var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
      return utils$2.merge(target, source);
    } else if (utils$2.isPlainObject(source)) {
      return utils$2.merge({}, source);
    } else if (utils$2.isArray(source)) {
      return source.slice();
    }

    return source;
  } // eslint-disable-next-line consistent-return


  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  } // eslint-disable-next-line consistent-return


  function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  } // eslint-disable-next-line consistent-return


  function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  } // eslint-disable-next-line consistent-return


  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };
  utils$2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    utils$2.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};

var data = {
  "version": "0.24.0"
};
var VERSION = data.version;
var validators$1 = {}; // eslint-disable-next-line func-names

['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
  validators$1[type] = function validator(thing) {
    return _typeof(thing) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});
var deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */

validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  } // eslint-disable-next-line func-names


  return function (value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true; // eslint-disable-next-line no-console

      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
    }

    return validator ? validator(value, opt, opts) : true;
  };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */


function assertOptions(options, schema, allowUnknown) {
  if (_typeof(options) !== 'object') {
    throw new TypeError('options must be an object');
  }

  var keys = Object.keys(options);
  var i = keys.length;

  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];

    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);

      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }

      continue;
    }

    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator$1 = {
  assertOptions: assertOptions,
  validators: validators$1
};
var utils$1 = utils$d;
var buildURL = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */

function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */


Axios$1.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig$1(this.defaults, config); // Set config.method

  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators["boolean"]),
      forcedJSONParsing: validators.transitional(validators["boolean"]),
      clarifyTimeoutError: validators.transitional(validators["boolean"])
    }, false);
  } // filter out skipped interceptors


  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);

    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }

  var newConfig = config;

  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();

    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
}; // Provide aliases for supported request methods


utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function (url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});
utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function (url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel = Cancel_1;
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */

function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this; // eslint-disable-next-line func-names

  this.promise.then(function (cancel) {
    if (!token._listeners) return;
    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }

    token._listeners = null;
  }); // eslint-disable-next-line func-names

  this.promise.then = function (onfulfilled) {
    var _resolve; // eslint-disable-next-line func-names


    var promise = new Promise(function (resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */


CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
/**
 * Subscribe to the cancel signal
 */


CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
/**
 * Unsubscribe from the cancel signal
 */


CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }

  var index = this._listeners.indexOf(listener);

  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */


CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */


var isAxiosError = function isAxiosError(payload) {
  return _typeof(payload) === 'object' && payload.isAxiosError === true;
};

var utils = utils$d;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */

function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context); // Copy axios.prototype to instance

  utils.extend(instance, Axios.prototype, context); // Copy context to instance

  utils.extend(instance, context); // Factory for creating new instances

  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
} // Create the default instance to be exported


var axios$1 = createInstance(defaults); // Expose Axios class to allow class inheritance

axios$1.Axios = Axios; // Expose Cancel & CancelToken

axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version; // Expose all/spread

axios$1.all = function all(promises) {
  return Promise.all(promises);
};

axios$1.spread = spread; // Expose isAxiosError

axios$1.isAxiosError = isAxiosError;
axios$2.exports = axios$1; // Allow use of default import syntax in TypeScript

axios$2.exports["default"] = axios$1;
var axios = axios$2.exports;
var instance = axios.create({
  headers: {
    'content-type': 'application/json'
  }
});

var fetchToken = function fetchToken(_a) {
  var authUrl = _a.authUrl,
      clientId = _a.clientId,
      clientSecret = _a.clientSecret;
  var payload = {
    grant_type: 'password',
    client_id: clientId,
    client_secret: clientSecret
  };
  return instance.post(authUrl, payload);
};

var eitherHasConfig = function eitherHasConfig(config) {
  return !config ? Either.left(new Error('Config is missing')) : Either.right(config);
};

var eitherHasSessionId = function eitherHasSessionId(sessionId) {
  return !sessionId ? Either.left(new Error('SessionId is missing')) : Either.right(sessionId);
};

var eitherHasToken = function eitherHasToken(token) {
  return !token ? Either.left(new Error('Token NOT declared, call getToken or pass token on new BEE')) : Either.right(token);
};

var eitherHasTemplate = function eitherHasTemplate(template) {
  return !template ? Either.left(new Error('template is missing')) : Either.right(template);
};

var eitherCheckJoinParams = function eitherCheckJoinParams(config, sessionId, token) {
  return _function.pipe(eitherHasSessionId(sessionId), Either.chain(function () {
    return eitherHasConfig(config);
  }), Either.chain(function () {
    return eitherHasToken(token);
  }));
};

var eitherCheckStartParams = function eitherCheckStartParams(config, template, token) {
  return _function.pipe(eitherHasConfig(config), Either.chain(function () {
    return eitherHasToken(token);
  }), Either.chain(function () {
    return eitherHasTemplate(template);
  }));
};

var eitherBeeInstanceExist = function eitherBeeInstanceExist(instance) {
  return !instance ? Either.left(new Error('Bee is not started')) : Either.right(instance);
};

var eitherIsValidAction = function eitherIsValidAction(action) {
  return !Object.keys(beeActions).some(function (x) {
    return beeActions[x] === action;
  }) ? Either.left(new Error("".concat(action, " is not a correct method"))) : Either.right(action);
};

var eitherCanExecuteAction = function eitherCanExecuteAction(instance, action) {
  return _function.pipe(eitherBeeInstanceExist(instance), Either.chain(function () {
    return eitherIsValidAction(action);
  }));
};

var StageModeOptions;

(function (StageModeOptions) {
  StageModeOptions["DESKTOP"] = "desktop";
  StageModeOptions["MOBILE"] = "mobile";
})(StageModeOptions || (StageModeOptions = {}));

var StageDisplayOptions;

(function (StageDisplayOptions) {
  StageDisplayOptions["BLUR"] = "blur";
  StageDisplayOptions["HIDE"] = "hide";
})(StageDisplayOptions || (StageDisplayOptions = {}));

var LoadWorkspaceOptions;

(function (LoadWorkspaceOptions) {
  LoadWorkspaceOptions["DEFAULT"] = "default";
  LoadWorkspaceOptions["MIXED"] = "mixed";
  LoadWorkspaceOptions["AMP_ONLY"] = "amp_only";
  LoadWorkspaceOptions["HTML_ONLY"] = "html_only";
})(LoadWorkspaceOptions || (LoadWorkspaceOptions = {}));

var BeePluginErrorCodes;

(function (BeePluginErrorCodes) {
  BeePluginErrorCodes[BeePluginErrorCodes["SAVE_UNAVAILABLE"] = 1000] = "SAVE_UNAVAILABLE";
  BeePluginErrorCodes[BeePluginErrorCodes["AMP_CONTENT_DETECTED"] = 1001] = "AMP_CONTENT_DETECTED";
  BeePluginErrorCodes[BeePluginErrorCodes["INVALID_TEMPLATES"] = 1100] = "INVALID_TEMPLATES";
  BeePluginErrorCodes[BeePluginErrorCodes["TEMPLATE_CANNOT_SAVED"] = 1200] = "TEMPLATE_CANNOT_SAVED";
  BeePluginErrorCodes[BeePluginErrorCodes["LOCKED_ROW_CLICKED"] = 1300] = "LOCKED_ROW_CLICKED";
  BeePluginErrorCodes[BeePluginErrorCodes["LOCKED_MODULE_CLICKED"] = 1310] = "LOCKED_MODULE_CLICKED";
  BeePluginErrorCodes[BeePluginErrorCodes["WORKSPACE_NOT_AVAILABLE"] = 1002] = "WORKSPACE_NOT_AVAILABLE";
  BeePluginErrorCodes[BeePluginErrorCodes["GENERIC_BUMP_ERROR"] = 2000] = "GENERIC_BUMP_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["INVALID_TARGET_VERSION"] = 2100] = "INVALID_TARGET_VERSION";
  BeePluginErrorCodes[BeePluginErrorCodes["VALIDATION_ERROR_DETAIL"] = 2200] = "VALIDATION_ERROR_DETAIL";
  BeePluginErrorCodes[BeePluginErrorCodes["MISSING_TEMPLATE_VERSION"] = 2300] = "MISSING_TEMPLATE_VERSION";
  BeePluginErrorCodes[BeePluginErrorCodes["INVALID_TEMPLATE_VERSION"] = 2400] = "INVALID_TEMPLATE_VERSION";
  BeePluginErrorCodes[BeePluginErrorCodes["TRASFORMATION_ERROR"] = 2500] = "TRASFORMATION_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["BACKWARD_TRASFORMATION_ERROR"] = 2600] = "BACKWARD_TRASFORMATION_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["SERVICE_ERROR"] = 3000] = "SERVICE_ERROR"; //File System provider errors

  BeePluginErrorCodes[BeePluginErrorCodes["FSP_GENERIC_ERROR"] = 3001] = "FSP_GENERIC_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["FSP_BE_GENERIC_ERROR"] = 3100] = "FSP_BE_GENERIC_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["FSP_RESOURCE_NOT_FOUND"] = 3200] = "FSP_RESOURCE_NOT_FOUND";
  BeePluginErrorCodes[BeePluginErrorCodes["FSP_PERMISSION_DENIED"] = 3300] = "FSP_PERMISSION_DENIED";
  BeePluginErrorCodes[BeePluginErrorCodes["FSP_RESOURCE_ALREADY_EXIST"] = 3400] = "FSP_RESOURCE_ALREADY_EXIST";
  BeePluginErrorCodes[BeePluginErrorCodes["FSP_FILE_NOT_UPLOADED"] = 3450] = "FSP_FILE_NOT_UPLOADED";
  BeePluginErrorCodes[BeePluginErrorCodes["FSP_REQUEST_ERROR"] = 3500] = "FSP_REQUEST_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["FSP_USER_ERROR"] = 3600] = "FSP_USER_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["FSP_WRONG_CREDENTIALS"] = 3650] = "FSP_WRONG_CREDENTIALS"; //Auth Errors

  BeePluginErrorCodes[BeePluginErrorCodes["AUTH_HEADER_MISSING"] = 4001] = "AUTH_HEADER_MISSING";
  BeePluginErrorCodes[BeePluginErrorCodes["AUTH_BEARER_INVALID"] = 4005] = "AUTH_BEARER_INVALID";
  BeePluginErrorCodes[BeePluginErrorCodes["AUTH_TOKEN_EXPIRED"] = 4010] = "AUTH_TOKEN_EXPIRED"; //Bump error

  BeePluginErrorCodes[BeePluginErrorCodes["BUMP_SERVICE_ERROR"] = 4015] = "BUMP_SERVICE_ERROR"; //JSON pre-processing errors

  BeePluginErrorCodes[BeePluginErrorCodes["JSON_GENERIC_ERROR"] = 4101] = "JSON_GENERIC_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_CODE_TAG_ERROR"] = 4105] = "JSON_CODE_TAG_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_HTML_BLOCK_ERROR"] = 4110] = "JSON_HTML_BLOCK_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_CONDITIONAL_STATEMENT_ERROR"] = 4115] = "JSON_CONDITIONAL_STATEMENT_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_ADD_ROW_CONDITIONAL_STATEMENT_ERROR"] = 4120] = "JSON_ADD_ROW_CONDITIONAL_STATEMENT_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_ADD_ROW_STYLE_ERROR"] = 4125] = "JSON_ADD_ROW_STYLE_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_ADD_ROW_CLASS_ERROR"] = 4130] = "JSON_ADD_ROW_CLASS_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_ADD_ROW_COMPUTED_STYLE_ERROR"] = 4135] = "JSON_ADD_ROW_COMPUTED_STYLE_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_CELL_WIDTH_ERROR"] = 4140] = "JSON_CELL_WIDTH_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_ADD_COLUMN_BACKGROUND_ERROR"] = 4145] = "JSON_ADD_COLUMN_BACKGROUND_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_MAIN_CSS_ERROR"] = 4190] = "JSON_MAIN_CSS_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_MAIN_CSS_MEDIA_ERROR"] = 4191] = "JSON_MAIN_CSS_MEDIA_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_SPECIFIC_CSS_ERROR"] = 4192] = "JSON_SPECIFIC_CSS_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_CSS_RULE_ERROR"] = 4501] = "JSON_CSS_RULE_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_CSS_GENERALE_PAGE_ERROR"] = 4502] = "JSON_CSS_GENERALE_PAGE_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_BODY_CSS_ERROR"] = 4503] = "JSON_BODY_CSS_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["JSON_COVERTING_CSS_ERROR"] = 4504] = "JSON_COVERTING_CSS_ERROR"; //HTML creation errors

  BeePluginErrorCodes[BeePluginErrorCodes["HTML_TO_JSON_CONVERT_ERROR"] = 4201] = "HTML_TO_JSON_CONVERT_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_COMMUNICATION_TO_JSON__ERROR"] = 4202] = "HTML_COMMUNICATION_TO_JSON__ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_COMMUNICATION_WORKER_TEXT_ERROR"] = 4210] = "HTML_COMMUNICATION_WORKER_TEXT_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_TEXT_ERROR"] = 4211] = "HTML_TEXT_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_COMMUNICATION_WORKER_BUTTON_ERROR"] = 4220] = "HTML_COMMUNICATION_WORKER_BUTTON_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_BUTTON_ERROR"] = 4221] = "HTML_BUTTON_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_COMMUNICATION_WORKER_VIDEO_ERROR"] = 4230] = "HTML_COMMUNICATION_WORKER_VIDEO_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_VIDEO_ERROR"] = 4231] = "HTML_VIDEO_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_COMMUNICATION_WORKER_SOCIAL_ERROR"] = 4240] = "HTML_COMMUNICATION_WORKER_SOCIAL_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_SOCIAL_ERROR"] = 4241] = "HTML_SOCIAL_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_COMMUNICATION_WORKER_ICON_ERROR"] = 4242] = "HTML_COMMUNICATION_WORKER_ICON_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_ICON_ERROR"] = 4243] = "HTML_ICON_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_COMMUNICATION_WORKER_MENU_ERROR"] = 4244] = "HTML_COMMUNICATION_WORKER_MENU_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_MENU_ERROR"] = 4245] = "HTML_MENU_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_COMMUNICATION_WORKER_IMAGE_ERROR"] = 4250] = "HTML_COMMUNICATION_WORKER_IMAGE_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_IMAGE_ERROR"] = 4251] = "HTML_IMAGE_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_COMMUNICATION_WORKER_MG_ERROR"] = 4260] = "HTML_COMMUNICATION_WORKER_MG_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_CUSTOM_ADDON_ERROR"] = 4270] = "HTML_CUSTOM_ADDON_ERROR"; //POST-PROCESSING

  BeePluginErrorCodes[BeePluginErrorCodes["HTML_POST_GENERIC_ERROR"] = 4301] = "HTML_POST_GENERIC_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_POST_IMAGE_URI_ERROR"] = 4310] = "HTML_POST_IMAGE_URI_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_POST_CUSTOM_HTML_ERROR"] = 4320] = "HTML_POST_CUSTOM_HTML_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_POST_CUSTOM_CODE_TAG_ERROR"] = 4330] = "HTML_POST_CUSTOM_CODE_TAG_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["HTML_POST_DISPLAY_CONDITION"] = 4340] = "HTML_POST_DISPLAY_CONDITION"; //RENDERING ERRORS

  BeePluginErrorCodes[BeePluginErrorCodes["RENDER_GENERIC_ERROR"] = 4600] = "RENDER_GENERIC_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["RENDER_CLEAN_HTML_ERROR"] = 4601] = "RENDER_CLEAN_HTML_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["RENDER_CLEAN_TEXT_ERROR"] = 4602] = "RENDER_CLEAN_TEXT_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["RENDER_CHECK_FORM_ERROR"] = 4603] = "RENDER_CHECK_FORM_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["RENDER_VALIDATION_ERROR"] = 4604] = "RENDER_VALIDATION_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["RENDER_VIDEO_FORMAT_NOT_SUPPORTED_ERROR"] = 4605] = "RENDER_VIDEO_FORMAT_NOT_SUPPORTED_ERROR";
  BeePluginErrorCodes[BeePluginErrorCodes["POST_PROCESSING_FINAL_PAGE_ERROR"] = 4700] = "POST_PROCESSING_FINAL_PAGE_ERROR";
})(BeePluginErrorCodes || (BeePluginErrorCodes = {}));

var ModuleTypes = {
  DIVIDER: 'mailup-bee-newsletter-modules-divider',
  TEXT: 'mailup-bee-newsletter-modules-text',
  IMAGE: 'mailup-bee-newsletter-modules-image',
  BUTTON: 'mailup-bee-newsletter-modules-button',
  HTML: 'mailup-bee-newsletter-modules-html',
  SOCIAL: 'mailup-bee-newsletter-modules-social',
  EMPTY: 'mailup-bee-newsletter-modules-empty',
  VIDEO: 'mailup-bee-newsletter-modules-video',
  ADDON: 'mailup-bee-newsletter-modules-addon',
  FORM: 'mailup-bee-newsletter-modules-form',
  MERGE_CONTENT: 'mailup-bee-newsletter-modules-merge-content',
  CAROUSEL: 'mailup-bee-newsletter-modules-carousel',
  MENU: 'mailup-bee-newsletter-modules-menu',
  ICONS: 'mailup-bee-newsletter-modules-icons',
  HEADING: 'mailup-bee-newsletter-modules-heading',
  SPACER: 'mailup-bee-newsletter-modules-spacer',
  PARAGRAPH: 'mailup-bee-newsletter-modules-paragraph',
  LIST: 'mailup-bee-newsletter-modules-list'
};
var ModuleDescriptorNames = {
  DIVIDER: 'divider',
  TEXT: 'text',
  IMAGE: 'image',
  BUTTON: 'button',
  HTML: 'html',
  SOCIAL: 'social',
  VIDEO: 'video',
  ADDON: 'addon',
  FORM: 'form',
  MERGE_CONTENT: 'mergeContent',
  CAROUSEL: 'carousel',
  MENU: 'menu',
  ICONS: 'icons',
  HEADING: 'heading',
  SPACER: 'spacer',
  PARAGRAPH: 'paragraph',
  LIST: 'list'
};
var RowLayoutType = {
  ONE_COLUMNS_EMPTY: 'one-column-empty',
  TWO_COLUMNS_EMPTY: 'two-columns-empty',
  TWO_COLUMNS_4_8_EMPTY: 'two-columns-4-8-empty',
  TWO_COLUMNS_8_4_EMPTY: 'two-columns-8-4-empty',
  TWO_COLUMNS_3_9_EMPTY: 'two-columns-3-9-empty',
  TWO_COLUMNS_9_3_EMPTY: 'two-columns-9-3-empty',
  THREE_COLUMNS_EMPTY: 'three-columns-empty',
  THREE_COLUMNS_3_3_6_EMPTY: 'three-columns-3-3-6-empty',
  THREE_COLUMNS_3_6_3_EMPTY: 'three-columns-3-6-3-empty',
  THREE_COLUMNS_6_3_3_EMPTY: 'three-columns-6-3-3-empty',
  FOUR_COLUMNS_EMPTY: 'four-columns-empty',
  SIX_COLUMNS_EMPTY: 'six-columns-empty'
};
var EngageHandle;

(function (EngageHandle) {
  EngageHandle["MDM"] = "mdm";
})(EngageHandle || (EngageHandle = {}));

var OnCommentChangeEnum;

(function (OnCommentChangeEnum) {
  OnCommentChangeEnum["NEWCOMMENT"] = "NEW_COMMENT";
  OnCommentChangeEnum["DELETECOMMENT"] = "COMMENT_DELETED";
  OnCommentChangeEnum["CHANGECOMMENT"] = "COMMENT_EDITED";
})(OnCommentChangeEnum || (OnCommentChangeEnum = {}));

var WorkspaceStage;

(function (WorkspaceStage) {
  WorkspaceStage["desktop"] = "desktop";
  WorkspaceStage["mobile"] = "mobile";
  WorkspaceStage["global"] = "global";
})(WorkspaceStage || (WorkspaceStage = {}));

var BeePluginRoles;

(function (BeePluginRoles) {
  BeePluginRoles["REVIEWER"] = "reviewer";
})(BeePluginRoles || (BeePluginRoles = {}));

var bee = /*#__PURE__*/Object.freeze({
  __proto__: null,

  get StageModeOptions() {
    return StageModeOptions;
  },

  get StageDisplayOptions() {
    return StageDisplayOptions;
  },

  get LoadWorkspaceOptions() {
    return LoadWorkspaceOptions;
  },

  get BeePluginErrorCodes() {
    return BeePluginErrorCodes;
  },

  ModuleTypes: ModuleTypes,
  ModuleDescriptorNames: ModuleDescriptorNames,
  RowLayoutType: RowLayoutType,

  get EngageHandle() {
    return EngageHandle;
  },

  get OnCommentChangeEnum() {
    return OnCommentChangeEnum;
  },

  get WorkspaceStage() {
    return WorkspaceStage;
  },

  get BeePluginRoles() {
    return BeePluginRoles;
  }

});
var BEEJS_URL = 'https://app-rsrc.getbee.io/plugin/BeePlugin.js';
var API_AUTH_URL = 'https://auth.getbee.io/apiauth';
var beeLoaderUrl = {
  beePluginUrl: '',
  authUrl: ''
};

var load = function load(bee) {
  loadScript(beeLoaderUrl.beePluginUrl, function (err) {
    if (err) {
      throw new Error('BeePlugin.js is not reachable');
    }

    return bee();
  });
};

var LOAD = beeActions.LOAD,
    SAVE = beeActions.SAVE,
    SEND = beeActions.SEND,
    PREVIEW = beeActions.PREVIEW,
    SAVE_AS_TEMPLATE = beeActions.SAVE_AS_TEMPLATE,
    TOGGLE_STRUCTURE = beeActions.TOGGLE_STRUCTURE,
    TOGGLE_COMMENTS = beeActions.TOGGLE_COMMENTS,
    TOGGLE_PREVIEW = beeActions.TOGGLE_PREVIEW,
    TOGGLE_MERGETAGS_PREVIEW = beeActions.TOGGLE_MERGETAGS_PREVIEW,
    SHOW_COMMENT = beeActions.SHOW_COMMENT,
    RELOAD = beeActions.RELOAD,
    LOAD_WORKSPACE = beeActions.LOAD_WORKSPACE,
    LOAD_STAGE_MODE = beeActions.LOAD_STAGE_MODE,
    LOAD_CONFIG = beeActions.LOAD_CONFIG;

var Bee = function () {
  function Bee(token, urlConfig) {
    if (urlConfig === void 0) {
      urlConfig = {
        authUrl: API_AUTH_URL,
        beePluginUrl: BEEJS_URL
      };
    }

    var _this = this;

    this.getToken = function (clientId, clientSecret, urlConfig) {
      if (urlConfig === void 0) {
        urlConfig = {
          authUrl: API_AUTH_URL,
          beePluginUrl: BEEJS_URL
        };
      }

      beeLoaderUrl = urlConfig;

      if (_this.token) {
        throw new Error('Toker already declared');
      }

      return fetchToken({
        authUrl: urlConfig.authUrl,
        clientId: clientId,
        clientSecret: clientSecret
      }).then(function (res) {
        _this.token = res.data;
        return res.data;
      });
    };

    this.start = function (config, template, bucketDir, options) {
      var _a = _this,
          bee = _a.bee,
          token = _a.token;
      return _function.pipe(eitherCheckStartParams(config, template, token), Either.fold(function (_a) {
        var message = _a.message;
        return new Promise(function (reject) {
          return reject(message);
        });
      }, function () {
        return new Promise(function (resolve) {
          bee(function () {
            return BeePlugin.create(token, _assign(_assign({}, config), {
              startOrigin: '[npm] @mailupinc/bee-plugin'
            }), function (instance) {
              _this.instance = instance;
              instance.start(template, options);
              resolve(instance);
            }, bucketDir);
          });
        });
      }));
    };

    this.join = function (config, sessionId, bucketDir) {
      var _a = _this,
          bee = _a.bee,
          token = _a.token;
      return _function.pipe(eitherCheckJoinParams(config, sessionId, _this.token), Either.fold(function (_a) {
        var message = _a.message;
        throw new Error(message);
      }, function () {
        return new Promise(function (resolve) {
          bee(function () {
            return BeePlugin.create(token, config, function (instance) {
              _this.instance = instance;
              instance.join(sessionId);
              resolve(instance);
            }, bucketDir);
          });
        });
      }));
    };

    this.executeAction = function (action, param, options) {
      if (param === void 0) {
        param = {};
      }

      if (options === void 0) {
        options = {};
      }

      var instance = _this.instance;

      _function.pipe(eitherCanExecuteAction(instance, action), Either.fold(function (_a) {
        var message = _a.message;
        throw new Error(message);
      }, function () {
        return instance[action](param, options);
      }));
    };

    this.load = function (template) {
      return _this.executeAction(LOAD, template);
    };

    this.save = function () {
      return _this.executeAction(SAVE);
    };

    this.saveAsTemplate = function () {
      return _this.executeAction(SAVE_AS_TEMPLATE);
    };

    this.send = function () {
      return _this.executeAction(SEND);
    };

    this.preview = function () {
      return _this.executeAction(PREVIEW);
    };

    this.toggleStructure = function () {
      return _this.executeAction(TOGGLE_STRUCTURE);
    };

    this.togglePreview = function () {
      return _this.executeAction(TOGGLE_PREVIEW);
    };

    this.toggleComments = function () {
      return _this.executeAction(TOGGLE_COMMENTS);
    };

    this.toggleMergeTagsPreview = function () {
      return _this.executeAction(TOGGLE_MERGETAGS_PREVIEW);
    };

    this.showComment = function (comment) {
      return _this.executeAction(SHOW_COMMENT, comment);
    };

    this.reload = function (template, options) {
      return _this.executeAction(RELOAD, template, options);
    };

    this.loadWorkspace = function (type) {
      return _this.executeAction(LOAD_WORKSPACE, type);
    };

    this.loadStageMode = function (args) {
      return _this.executeAction(LOAD_STAGE_MODE, args);
    };

    this.loadConfig = function (args) {
      return _this.executeAction(LOAD_CONFIG, args);
    };

    beeLoaderUrl = urlConfig;

    this.bee = function (call) {
      return load(function () {
        return call();
      });
    };

    this.token = token || '';
    this.instance = null;
  }

  return Bee;
}();

export { bee as beeTypes, Bee as default };